import _ from 'lodash'

import { d } from 'core/service/lib/decimal'

export const calculateRPU = (RPURate, sumAssured) => {
  if (RPURate < 0) return { RPUSumAssured: 0, RPUCashpaid: 0 }
  const RPURateSA = RPURate > 1000 ? 1000 : RPURate
  const RPURateCashpaid = RPURate > 1000 ? RPURate - 1000 : 0

  const multiplyResult = d(sumAssured).dividedBy(1000)
  return {
    RPUSumAssured: d(multiplyResult)
      .times(d(RPURateSA))
      .toNumber(),
    RPUCashpaid: d(multiplyResult)
      .times(d(RPURateCashpaid))
      .toNumber(),
  }
}

export const calculateETI = (ETIRate, PENRate, sumAssured) => {
  const PENRateMaturity = PENRate > 1000 ? 1000 : PENRate < 0 ? 0 : PENRate
  const PENRateCashpaid = PENRate > 1000 ? PENRate - 1000 : 0

  const multiplyResult = d(sumAssured).dividedBy(1000)

  return {
    ETIMaturity: d(multiplyResult)
      .times(d(PENRateMaturity))
      .toNumber(),
    ETICashpaid: d(multiplyResult)
      .times(d(PENRateCashpaid))
      .toNumber(),
    ETIYear: Math.floor(ETIRate / 1000),
    ETIDay: ETIRate % 1000,
  }
}

export const findRPURate = (productCode, RPURates) => _.find(RPURates, (rate) => rate.productCode === productCode)

export const findPENRate = (productCode, PENRates) => _.find(PENRates, (rate) => rate.productCode === productCode)

export const findETIRate = (productCode, ETIRates) => _.find(ETIRates, (rate) => rate.productCode === productCode)

export const queryRPURate = (gender, age, policyYear, filteredRPURates) => {
  const queryAge = age.unit !== 'year' ? 0 : age.value

  return _.get(filteredRPURates, ['RPURates', gender, queryAge.toString(), policyYear.toString()], 0)
}

export const queryPENRate = (gender, age, policyYear, filteredPENRates) => {
  const queryAge = age.unit !== 'year' ? 0 : age.value

  return _.get(filteredPENRates, ['PENRates', gender, queryAge.toString(), policyYear.toString()], 0)
}

export const queryETIRate = (gender, age, policyYear, filteredETIRates) => {
  const queryAge = age.unit !== 'year' ? 0 : age.value

  return _.get(filteredETIRates, ['ETIRates', gender, queryAge.toString(), policyYear.toString()], 0)
}
